<template>
	<section id="service">
		<div class="container">
			<div class="row" data-aos="fade-up">
				<div class="col-md-12">
					<div class="heading">
						<h2>{{ $t('about.service') }}</h2>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 col-sm-4" v-for="s in services">
					<div class="features-box" style="height: 270px">
						<i :class="s.icon" aria-hidden="true"></i>
						<h4>{{ $i18n.locale === 'zh' ? s.c_title : s.e_title }}</h4>
						<p>{{ $i18n.locale === 'zh' ? s.c_content : s.e_content }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
  name: 'Service',
  data: () => ({
    services: [
      {'e_title': 'Recruiting', 'c_title': '招聘服务', 'e_content': 'Whether you are currently recruiting, looking for advice on industry recruitment trends or simply want to source information on expected salary rates, we can help.', 'c_content': '无论您是否正在进行招聘工作、寻找行业招聘动向，或仅想要查询期望薪酬方面的信息，我们都可以为您提供专业的帮助。', 'icon': 'theme-cl ti-ruler-pencil'},
      {'e_title': 'RPO', 'c_title': 'RPO', 'e_content': 'ER is not only a recruitment company, but also a comprehensive talent recruitment project management solution tailored to meet the recruitment goals of different levels and regions.', 'c_content': 'ER不仅仅是一家招聘公司，还能够为客户度身定制全面的人才招聘项目管理方案，满足其在不同级别、不同地区的招聘目标。', 'icon': 'theme-cl ti-headphone-alt'},
      {'e_title': 'Staffing', 'c_title': '人才派遣', 'e_content': 'ER is committed to helping employers find the right external staff. If you need to find an outsider for a project, you are welcome to contact our expert consultants.', 'c_content': 'ER致力于帮助雇主找到合适的外聘人员。如果您需要为某个项目寻找外聘人员，欢迎即刻联系我们的专家顾问。', 'icon': 'theme-cl ti-paint-bucket'}
    ]
  })
}
</script>